import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac196c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "k-done-btn__ring" }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "k-done-btn__label" }, " Done! ", -1))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

import { ref } from 'vue';
import { useMotion, MotionVariants, useMotions } from '@vueuse/motion';
import { hapticsImpactLight } from 'src/util/device-util';


export default /*#__PURE__*/_defineComponent({
  __name: 'done-button',
  props: {
    width: [Number, String]
},
  emits: ['click'],
  setup(__props, { expose, emit }) {

_useCssVars(_ctx => ({
  "a4314644": (_ctx.$props.width)
}))




const btn = ref();
const motion = useMotion(btn, {
    initial: {
        opacity: 0,
        scale: 0
    },
    enter: {
        opacity: 1,
        scale: 1,
        transition: {
            duration: 500,
            ease: 'spring'
        }
    },
    leave: {
        opacity: 0,
        scale: 1.5,
        transition: {
            duration: 250,
            ease: 'easeIn'
        },
    }
})


const handleClick = () => {
    hapticsImpactLight();
    motion.apply('leave');
    emit('click');
}

expose({
    leave: () => motion.apply('leave')
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _mergeProps({
    ref_key: "btn",
    ref: btn,
    class: "k-done-btn"
  }, _ctx.$attrs, { onPointerdownOnce: handleClick }), _hoisted_3, 16))
}
}

})